import Cookies from 'js-cookie';
// 直接引用编译产物子路径，避免触发 @cap/utils 顶层入口（src/index.ts）中
// 存在类型缺陷的 clientUA 模块解析，导致 next build 类型检查失败
import generateLXCUID from '@cap/utils/lib/generateLXCUID/index';

const uuidKey = '_officeweb';

/**
 * 获取 Web 端 uuid，取值优先级：
 * 1. cookie.uuid（Web 容器团队注入）
 * 2. cookie.iuuid（美团 i 版团队注入）
 * 3. cookie._lxsdk_cuid（灵犀 Web SDK 注入）
 * 4. cookie._lxsdk（灵犀 Web SDK 注入）
 * 5. 自定义缓存 cookie（如无则生成 lxcuid 并写入，30 天有效期）
 */
export function getWebUUID(): string {
  let uuid = Cookies.get('uuid') || Cookies.get('iuuid') || Cookies.get('_lxsdk_cuid') || Cookies.get('_lxsdk');

  if (!uuid) {
    const cacheKey = `_officewebuser${uuidKey}`;
    uuid = Cookies.get(cacheKey);

    if (!uuid) {
      uuid = generateLXCUID();
      Cookies.set(cacheKey, uuid, {
        expires: 30, // 过期时间30天
      });
    }
  }

  return uuid;
}
